<template>
  <div class="common-menu">
    <b-navbar toggleable="sm" type="dark" :variant="color" fixed="top">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item to="/product">製品情報</b-nav-item>
          <b-nav-item to="/board">掲示板</b-nav-item>
          <b-nav-item-dropdown v-if="loginLevel >= 2">
            <template #button-content>
              管理
            </template>
            <b-dropdown-item to="/user">ユーザー管理</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item to="/policy">利用規約</b-nav-item>
          <b-nav-item-dropdown right>
            <template #button-content>
              ユーザー
            </template>
            <b-dropdown-item to="/personal">設定</b-dropdown-item>
            <b-dropdown-item to="/auth/update">パスワード変更</b-dropdown-item>
            <b-dropdown-item to="/auth/logout">ログアウト</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CommonMenu',

  data() {
    let color = 'dark';
    if (process.env.VUE_APP_ENV == 'development') {
      color = 'danger';
    } else if (process.env.VUE_APP_ENV == 'staging') {
      color = 'primary';
    }
    return {
      color: color,
    };
  },

  computed: {
    ...mapState({
      loginLevel: state => state.auth.level,
    }),
  },
};
</script>

<style scoped>
</style>
